module.exports = __webpack_public_path__ + "img/cancel_1.cbafc0d4.png";